export { GoogleMapsEmbed as default } from './GoogleMapsEmbed';
